import { Link } from 'react-router-dom';
import React from 'react';

import Icon1 from '../../assets/img/features/haarmeso.jpg';
import Icon2 from '../../assets/img/features/dermapen.jpg';
import Icon3 from '../../assets/img/features/algenpeeling.jpeg';
import Icon4 from '../../assets/img/features/haarsen.jpg';
import Icon5 from '../../assets/img/features/laser .jpg';
import Icon6 from '../../assets/img/features/diptereinigen.jpg';
import Icon7 from '../../assets/img/features/chemische peeling.jpg';
import Icon8 from '../../assets/img/features/Microdermabrasie.jpg';
import Icon9 from '../../assets/img/features/prx.jpg';
import Icon10 from '../../assets/img/features/advice.jpg';
import Icon11 from '../../assets/img/features/meer.jpg';

import Img1 from "../../assets/img/logo/nlogo.png";

const Feature = () => {
    // 1. Updated data structure with SEO titles and Alt text
    const services = [
        { name: 'Mesotherapie', seoTitle: 'Mesotherapie in Arnhem', path: '/meso', img: Icon1 },
        { name: 'Microneedling (Dermapen)', seoTitle: 'Microneedling Dermapen Arnhem', path: '/dermapen', img: Icon2 },
        { name: 'Bio peel treatment', seoTitle: 'Bio peel treatment Algen Peeling Arnhem', path: '/algen', img: Icon3 },
        { name: 'Harsen', seoTitle: 'Harsen behandeling Arnhem', path: '/harsen', img: Icon4 },
        { name: 'Laser Therapie', seoTitle: 'Laser Therapie Arnhem', path: '/laser', img: Icon5 },
        { name: 'Dipte reiniging', seoTitle: 'Dieptereiniging gezicht Arnhem', path: '/dipte', img: Icon6 },
        { name: 'Chemische Peeling', seoTitle: 'Chemische Peeling Arnhem', path: '/chemische', img: Icon7 },
        { name: 'Microdermabrasie', seoTitle: 'Microdermabrasie Arnhem', path: '/microderma', img: Icon8 },
        { name: 'PRX Behandeling', seoTitle: 'PRX-T33 Behandeling Arnhem', path: '/prx', img: Icon9 },
        { name: 'Een Advies nodig?', seoTitle: 'Huidadvies Arnhem', path: '/advice', img: Icon10 },
        { name: 'Ontdek meer schoonheid behandelingen', seoTitle: 'Meer schoonheid behandelingen Arnhem', url: 'https://amani-beauty-skin.salonized.com/widget_bookings/new', img: Icon11 }
    ];

    return (
        <section
            className="p-relative fix"
            style={{
                backgroundColor: '#FFFCF8',
                padding: '60px 0'
            }}
        >

            <div
                style={{
                    textAlign: 'center',
                    backgroundColor: '#FFFCF8',
                    marginBottom: '40px'
                }}
            >
                <img
                    src={Img1}
                    alt="Amani Beauty Skin Logo Arnhem"
                    style={{
                        maxHeight: '80px'
                    }}
                />

                <h2
                    style={{
                        fontFamily: 'serif',
                        color: '#2B2B2B',
                        marginTop: '20px',
                        fontSize: '32px',
                        fontWeight: '400'
                    }}
                >
                    Ontdek Onze Diensten in Arnhem
                </h2>
            </div>

            <div className="container">
                <div className="row">

                    {services.map((item, index) => (

                        <div
                            key={index}
                            className="col-lg-4 col-md-6 col-sm-12 mb-4"
                        >

                            <div
                                style={{
                                    backgroundColor: '#F9F4EF',
                                    borderRadius: '16px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.03)'
                                }}
                            >

                                <div
                                    style={{
                                        width: '100%',
                                        height: '220px',
                                        overflow: 'hidden'
                                    }}
                                >

                                    <img
                                        src={item.img}
                                        alt={`${item.seoTitle} - Amani Beauty`}
                                        title={item.seoTitle}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />

                                </div>

                                <div
                                    style={{
                                        padding: '24px 20px',
                                        textAlign: 'center',
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >

                                    <span
                                        style={{
                                            fontSize: '12px',
                                            color: '#888',
                                            marginBottom: '6px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px'
                                        }}
                                    >
                                        Arnhem
                                    </span>

                                    {/* External booking link for the last card */}
                                    {item.url ? (

                                        <a
                                            href={item.url}
                                            aria-label={item.seoTitle}
                                            style={{
                                                backgroundColor: '#D0B397',
                                                color: '#ffffff',
                                                padding: '10px 22px',
                                                borderRadius: '8px',
                                                textDecoration: 'none',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                display: 'inline-block',
                                                transition: 'background-color 0.3s ease'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.backgroundColor = '#BFA082';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.backgroundColor = '#D0B397';
                                            }}
                                        >
                                            {item.name}
                                        </a>

                                    ) : (

                                        <Link
                                            to={item.path}
                                            aria-label={item.seoTitle}
                                            style={{
                                                backgroundColor: '#D0B397',
                                                color: '#ffffff',
                                                padding: '10px 22px',
                                                borderRadius: '8px',
                                                textDecoration: 'none',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                display: 'inline-block',
                                                transition: 'background-color 0.3s ease'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.backgroundColor = '#BFA082';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.backgroundColor = '#D0B397';
                                            }}
                                        >
                                            {item.name}
                                        </Link>

                                    )}

                                </div>

                            </div>

                        </div>

                    ))}

                </div>
            </div>

        </section>
    );
};

export default Feature;